<script>
export default {
  data() {
    return {
      title: "Categories",
      text: "Categories",
    };
  },
};
</script>
<template>
  <layout-header></layout-header>
  <services-breadcrumb :title="title" :text="text" />
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content content-two">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-26.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="inner-content d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-01.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Construction</h5>
                  </div>
                  <p class="fs-14 me-2">10 Services</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-28.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-02.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Removal</h5>
                  </div>
                  <p class="fs-14 me-2">45 Services</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-29.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-05.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Electrical</h5>
                  </div>
                  <p class="fs-14 me-2">66 Services</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-30.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-03.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Furniture Assembly</h5>
                  </div>
                  <p class="fs-14 me-2">45 Services</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-44.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-07.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Deliveries</h5>
                  </div>
                  <p class="fs-14 me-2">40 Services</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-33.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-14.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Cleaning</h5>
                  </div>
                  <p class="fs-14 me-2">21 Services</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-34.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-06.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Man and van</h5>
                  </div>
                  <p class="fs-14 me-2">21 Services</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-46.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-08.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Mobile Barbers</h5>
                  </div>
                  <p class="fs-14 me-2">16 Services</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-37.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-15.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Car Transport</h5>
                  </div>
                  <p class="fs-14 me-2">14 Services</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-35.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-11.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Nail Technicians</h5>
                  </div>
                  <p class="fs-14 me-2">74 Services</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-38.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-12.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Hair Dressers</h5>
                  </div>
                  <p class="fs-14 me-2">21 Services</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-42.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-09.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Interior</h5>
                  </div>
                  <p class="fs-14 me-2">45 Services</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-41.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-16.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Carpenter</h5>
                  </div>
                  <p class="fs-14 me-2">22 Services</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-43.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-17.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Car Wash</h5>
                  </div>
                  <p class="fs-14 me-2">15 Services</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="category-list rounded mb-4">
              <a href="javascript:void(0);">
                <img
                  src="@/assets/img/services/service-40.jpg"
                  class="img-fluid"
                  alt="img"
                />
                <div
                  class="service-img bg-secondary d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <span
                      class="service-icon bg-primary avatar avatar-md text-white me-2"
                    >
                      <img
                        src="@/assets/img/icons/category-10.svg"
                        class="img-fluid"
                        alt="logo"
                      />
                    </span>
                    <h5 class="text-white">Plumbing</h5>
                  </div>
                  <p class="fs-14 me-2">12 Services</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <pages-footer></pages-footer>
</template>
